import { render, staticRenderFns } from "./QuotationDetail.vue?vue&type=template&id=b7d413aa&scoped=true&"
import script from "./QuotationDetail.vue?vue&type=script&lang=js&"
export * from "./QuotationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d413aa",
  null
  
)

export default component.exports